import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
  showOriginal?: boolean;
  originalAmount?: number;
}
export function PriceDisplay({
  amount,
  className = '',
  showOriginal = false,
  originalAmount
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState({
    symbol: '$',
    locale: 'es-AR'
  });
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    let symbol = '$';
    let localeString = 'es-AR';
    if (locale.startsWith('es')) {
      symbol = '$';
      localeString = 'es-AR';
    } else if (locale === 'en-GB') {
      symbol = '£';
      localeString = 'en-GB';
    } else if (locale === 'en-US') {
      symbol = '$';
      localeString = 'en-US';
    } else if (locale.startsWith('de') || locale.startsWith('fr') || locale.startsWith('it') || locale.startsWith('es-ES')) {
      symbol = '€';
      localeString = 'de-DE';
    }
    setCurrency({
      symbol,
      locale: localeString
    });
  }, []);
  const formatPrice = (price: number) => {
    return price.toLocaleString(currency.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };
  return <span className={className} data-id="element-110">
      {showOriginal && originalAmount && <span className="line-through opacity-60 mr-2" data-id="element-111">
          {currency.symbol}
          {formatPrice(originalAmount)}
        </span>}
      <span className="font-bold" data-id="element-112">
        {currency.symbol}
        {formatPrice(amount)}
      </span>
    </span>;
}